<template>
  <i class="badge mr-5" :style="tagStyleObj">
    <i class="icon-lineIcon-master"></i>
    <span style="color: #222222; vertical-align: middle;">{{statusStr}}</span>
  </i>
</template>

<script>
  export default {
    props:['statusStr', 'bgColor'],
    data(){
      return {
        tagStyleObj: {
          background: this.bgColor,
          border: '0.5px solid #e2e2e2',
          height: '16px'
        }
      }
    },
  }
</script>

<style>

</style>